import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { setAuthToken } from '@/shared/api/http-client'
import type { AuthUser } from '@/features/auth/types'

interface AuthState {
  token: string | null
  user: AuthUser | null
  setSession: (token: string | null) => void
  setUser: (user: AuthUser | null) => void
  reset: () => void
}

const STORAGE_KEY = 'girls-auth-session'

export const useAuthStore = create<AuthState>()(
  persist<AuthState>(
    (set) => ({
      token: null,
      user: null,
      setSession: (token) => {
        setAuthToken(token)
        set({ token })
      },
      setUser: (user) => set({ user }),
      reset: () => {
        setAuthToken(null)
        set({ token: null, user: null })
      },
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        const token = state?.token ?? null
        setAuthToken(token)
      },
    },
  ),
)

export type { AuthState }
